export enum ESymbolEvents {
    SYMBOL_$_SHORT_ANIM_$ = 'SYMBOL_$_SHORT_ANIM_$'
}
